import 'core-js/stable';

import React from 'react';
import ReactDOM from 'react-dom/client';

// I18
import { I18nextProvider } from 'react-i18next';

// i18n translation
import i18 from './configs/i18n/i18n.config';

// Redux
import { Provider } from 'react-redux';

// React router
import { BrowserRouter } from 'react-router-dom';

// Global styles
import './index.scss';

// Components
import { App } from './pages/app';
import { BrowserNotSupported } from './pages/browser-not-supported/browser-not-supported';

import reportWebVitals from './reportWebVitals';

// Constants
import { minBrowsersSupport } from './constantes/global.constants';

// Store root reducer
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const hasRequiredFeatures = (): boolean => {
  return typeof ResizeObserver !== 'undefined'
    && typeof IntersectionObserver !== 'undefined'
    && typeof Intl !== 'undefined'
    && typeof Intl.RelativeTimeFormat === 'function'
    && typeof CSS !== 'undefined'
    && typeof CSS.supports === 'function'
    && CSS.supports('display', 'grid');
};

const isSupportedBrowser = (): boolean => {
  if (!hasRequiredFeatures()) {
    return false;
  }

  const userAgent = navigator.userAgent;
  let browserName = '';
  let browserVersion = 0;

  if (/Chrome|chromium|crios/i.test(userAgent) && /Google Inc|Apple Computer/i.test(navigator.vendor)) {
    const versionMatch = userAgent.match(/(?:Chrome|chromium|crios)\/(\d+)/i);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Chrome';
    }
  }

  if (/Firefox/.test(userAgent)) {
    const versionMatch = userAgent.match(/Firefox\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Firefox';
    }
  }

  if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
    const versionMatch = userAgent.match(/Version\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Safari';
    }
  }

  if (/Opera/.test(userAgent) || /OPR/.test(userAgent)) {
    const versionMatch = userAgent.match(/(?:Opera|OPR)\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Opera';
    }
  }

  if (/Edg/.test(userAgent)) {
    const versionMatch = userAgent.match(/Edg\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Edge';
    }
  }

  switch (browserName) {
    case 'Chrome':
      return browserVersion >= minBrowsersSupport.chrome;
    case 'Firefox':
      return browserVersion >= minBrowsersSupport.firefox;
    case 'Safari':
      return browserVersion >= minBrowsersSupport.safari;
    case 'Opera':
      return browserVersion >= minBrowsersSupport.opera;
    case 'Edge':
      return browserVersion >= minBrowsersSupport.edge;
    default:
      return true;
  }
};

const isBrowserSupported = isSupportedBrowser();

root.render(
  <I18nextProvider i18n={ i18 }>
    <Provider store={ store }>
      <BrowserRouter>
        {isBrowserSupported ? <App/> : <BrowserNotSupported/>}
      </BrowserRouter>
    </Provider>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// reportWebVitals(console.log);
